/**
 * Compare zone ids from URL params vs GraphQL (encoding may differ).
 *
 * @param {string|null|undefined} a - First zone id (e.g. route param or `getZone.id`).
 * @param {string|null|undefined} b - Second zone id (e.g. annotation `zoneId`).
 * @return {boolean} Whether the two ids refer to the same zone after decoding.
 */
export function zoneIdsMatch(
  a: string | null | undefined,
  b: string | null | undefined
): boolean {
  if (a == null || b == null || a === "" || b === "") {
    return false;
  }

  try {
    return decodeURIComponent(a) === decodeURIComponent(b);
  } catch {
    return a === b;
  }
}
